import axios from 'axios'

const multipartFormHeaders = {
  headers: {
    'Content-Type': 'multipart/form-data'
  }
}

export default {
  getCustomers: (page = 1, pagination = true, filters = {}) => axios.get('/customers', { params: { page: page, pagination: pagination, ...filters } }),
  getCustomer: (customerId) => axios.get(`/customers/${customerId}`),
  postCustomer: customer => axios.post('/customers', customer),
  putCustomer: (customerId, updatedCustomer) => axios.put(`/customers/${customerId}`, updatedCustomer),
  activateCustomer: (customerId) => axios.put(`/customers/${customerId}/active`, {}),
  archiveCustomer: (customerId) => axios.put(`/customers/${customerId}/archive`, {}),
  postBillCustomer: (customerId, billData) => axios.post(`/customers/${customerId}/bill`, billData, multipartFormHeaders),
  postTransferCustomer: (customerId, transferData) => axios.post(`/customers/${customerId}/transfer`, transferData, multipartFormHeaders),
  getUserMassiveImport: (id) => axios.get(`/user_massive_imports/${id}`),
  confirmMassiveImport: (id) => axios.put(`/user_massive_imports/${id}/confirm`),
  rejectMassiveImport: (id) => axios.delete(`/user_massive_imports/${id}`),
  putCustomerIbanTransfer: (id, transferData) => axios.put(`/customers/${id}/iban_transfer`, transferData),
  postCustomerPublic: (customerData) => axios.post('/customer/public', customerData),
  putRemoveOfficeUsers: (officeId) => axios.put(`/offices/${officeId}/remove_users`, {})
}
